import { createSupabaseClient } from '@applicator/shared'

import { captureAuthCallbackParamsIfNeeded } from './authCallbackCapture'
import { createAuthSentryFetch } from './authSentryReporting'
import {
  bootstrapAuthSessionRecovery,
  registerAuthSessionPageshowRecovery,
  registerAuthVisibilityWakeRecovery,
} from './authSessionPersistence'
import {
  clearLegacySupabaseHostArtifacts,
  clearStaleSupabaseAuthStorage,
  supabaseProjectRefFromUrl,
} from './supabaseProject'

captureAuthCallbackParamsIfNeeded()

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  const missing = []
  if (!supabaseUrl) missing.push('VITE_SUPABASE_URL')
  if (!supabaseAnonKey) missing.push('VITE_SUPABASE_ANON_KEY')

  throw new Error(
    `Missing Supabase environment variables: ${missing.join(', ')}\n` +
    `Please create a .env.local file in packages/web/ with these variables.\n` +
    `Example:\n` +
    `VITE_SUPABASE_URL=your_supabase_url\n` +
    `VITE_SUPABASE_ANON_KEY=your_supabase_anon_key`
  )
}

const projectRef = supabaseProjectRefFromUrl(supabaseUrl)
clearStaleSupabaseAuthStorage(projectRef)
clearLegacySupabaseHostArtifacts(projectRef)

export const supabase = createSupabaseClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: createAuthSentryFetch() },
})

registerAuthSessionPageshowRecovery(supabase)
registerAuthVisibilityWakeRecovery(supabase)

/** Await in RequireAuth before first redirect-to-login. */
export const authBootstrapPromise = bootstrapAuthSessionRecovery(supabase, projectRef)
